// src/Buttons/ContatoButton.js

import React from 'react';
import { Link } from 'react-router-dom';
import './ContatoButton.css';

export default function ContatoButton({ currentPath, buttonPath }) {
  const isActive = currentPath === buttonPath;

  return (
    <Link
      to={buttonPath}
      className={`ContatoButton ${isActive ? 'active' : ''}`}
    >
      CONTATOS
    </Link>
  );
}
